import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "referrals-page" };
const _hoisted_2 = { class: "page-toolbar" };
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import AdminTable from '@/admin/components/AdminTable.vue';
import { useAdminReferrals } from '@/composables/useAdminReferrals';
import { useAdmin } from '@/composables/useAdmin';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReferralsPage',
    setup(__props) {
        const router = useRouter();
        const { getReferrals } = useAdminReferrals();
        const admin = useAdmin();
        const loading = ref(true);
        const rows = ref([]);
        const columns = [
            { field: 'employer', label: 'Employer', sortable: true },
            { field: 'referrerName', label: 'Referrer', sortable: true },
            { field: 'referrerCode', label: 'Code', sortable: true },
            { field: 'refereeName', label: 'Referee', sortable: true },
            { field: 'usedDate', label: 'Code used', sortable: true, type: 'date' },
            { field: 'referrerCredit', label: 'Referrer credit', sortable: true },
            { field: 'refereeCredit', label: 'Referee credit', sortable: true },
            { field: 'creditedDate', label: 'Credited', sortable: true, type: 'date' },
        ];
        function personName(customer) {
            const p = customer?.person;
            return [p?.firstName, p?.lastName].filter(Boolean).join(' ') || '—';
        }
        function employerName(employerId) {
            if (!employerId)
                return '—';
            const found = admin.adminState.employers.find((e) => e.id === employerId);
            return found?.name ?? employerId;
        }
        function buildRows(referrals) {
            rows.value = referrals.map(r => ({
                employer: employerName(r.referrer?.employerID ?? null),
                referrerName: personName(r.referrer),
                referrerCode: r.referrer?.referralCode ?? '—',
                refereeName: personName(r.referee),
                usedDate: r.referralUsedDateTime,
                referrerCredit: r.referrerCreditAmount != null ? `£${r.referrerCreditAmount.toFixed(2)}` : '—',
                refereeCredit: r.refereeCreditAmount != null ? `£${r.refereeCreditAmount.toFixed(2)}` : '—',
                creditedDate: r.referrerCreditedDateTime,
            }));
        }
        onMounted(() => {
            admin.getEmployers();
            getReferrals((result) => {
                buildRows(result ?? []);
                loading.value = false;
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        class: "visualise-btn",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/admin/referrals/visualise')))
                    }, _cache[1] || (_cache[1] = [
                        _createStaticVNode("<span class=\"visualise-icon\" data-v-13f62af2>🕸️</span><span class=\"visualise-label\" data-v-13f62af2><span class=\"visualise-title\" data-v-13f62af2>Virality Graph</span><span class=\"visualise-sub\" data-v-13f62af2>Visualise MGM referral network</span></span><span class=\"visualise-arrow\" data-v-13f62af2>→</span>", 3)
                    ]))
                ]),
                _createVNode(AdminTable, {
                    title: "Referrals",
                    icon: "🎁",
                    columns: columns,
                    data: rows.value,
                    loading: loading.value,
                    searchable: true,
                    "empty-message": "No referrals found."
                }, null, 8, ["data", "loading"])
            ]));
        };
    }
});
